var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoxUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D26437"
    },
    d: "M439.893,4.169c11.115-4.246,23.06,4.141,22.543,16.028c-4.168,95.801-37.145,178.387-37.145,178.387 l-124.559-87.398C350.393,51.372,410.485,15.404,439.893,4.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B44632"
    },
    d: "M342.252,140.319c32.368-52.714,81.19-103.046,96.647-112.026c6.266-3.64,11.768,5.266,10.365,17.005 c-7.465,62.48-21.005,118.599-29.343,149.519L342.252,140.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D26437"
    },
    d: "M72.107,4.169C60.992-0.077,49.047,8.31,49.564,20.197c4.168,95.801,37.145,178.387,37.145,178.387 l124.559-87.398C161.607,51.372,101.515,15.404,72.107,4.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B44632"
    },
    d: "M169.748,140.319C137.38,87.605,88.558,37.273,73.101,28.293c-6.266-3.64-11.768,5.266-10.365,17.005 c7.465,62.48,21.005,118.599,29.343,149.519L169.748,140.319z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EBC9A0"
    },
    cx: 256,
    cy: 475.92,
    rx: 49.548,
    ry: 33.03
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC9A0"
    },
    d: "M198.194,467.659c-57.806-33.032-153.573-68.995-153.573-68.995l9.19-27.571 c-3.874-1.84-30.413-2.187-53.81,5.727l24.774-41.29h173.419V467.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC9A0"
    },
    d: "M313.806,467.659c57.806-33.032,153.573-68.995,153.573-68.995l-9.19-27.571 c3.874-1.84,30.413-2.187,53.81,5.727l-24.774-41.29H313.806V467.659z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB874B"
    },
    d: "M256,96.047c120.377,0,223.716,120.61,255.628,278.91c0.125,0.621,0.249,1.242,0.372,1.864 c0,0-60.903-62.968-126.968-29.419c-24.499,12.441-36.129,39.775-36.129,69.644c0,49.524-39.699,76.926-86.73,57.891 c-3.987-1.614-8.36-1.614-12.347,0c-47.031,19.036-86.73-8.366-86.73-57.891c0-29.869-11.631-57.203-36.129-69.644 C60.903,313.853,0,376.821,0,376.821c0.123-0.622,0.247-1.243,0.372-1.864C32.284,216.656,135.623,96.047,256,96.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M169.29,327.272L169.29,327.272c-15.897,0-28.903-13.006-28.903-28.903v-16.516 c0-15.897,13.006-28.903,28.903-28.903l0,0c15.897,0,28.903,13.006,28.903,28.903v16.516 C198.194,314.266,185.187,327.272,169.29,327.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M169.29,252.95c-1.413,0-2.769,0.221-4.129,0.419v40.871c0,9.121,7.395,16.516,16.516,16.516 c9.122,0,16.516-7.395,16.516-16.516v-12.387C198.194,265.956,185.187,252.95,169.29,252.95z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 169.29,
    cy: 273.6,
    r: 12.387
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M342.71,327.272L342.71,327.272c-15.897,0-28.903-13.006-28.903-28.903v-16.516 c0-15.897,13.006-28.903,28.903-28.903l0,0c15.897,0,28.903,13.006,28.903,28.903v16.516 C371.613,314.266,358.606,327.272,342.71,327.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M342.71,252.95c-1.413,0-2.769,0.221-4.129,0.419v40.871c0,9.121,7.395,16.516,16.516,16.516 c9.122,0,16.516-7.395,16.516-16.516v-12.387C371.613,265.956,358.606,252.95,342.71,252.95z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 342.71,
    cy: 273.6,
    r: 12.387
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D26437"
    },
    d: "M247.742,475.699c0.715-0.27,1.431-0.546,2.149-0.832c3.921-1.561,8.298-1.561,12.219,0 c0.718,0.286,1.434,0.562,2.149,0.832v-32.814h-16.516L247.742,475.699L247.742,475.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M255.523,393.337c18.507,0,33.51,12.262,33.51,27.389c0,14.588-14.083,22.269-24.247,27.949 c-5.892,3.292-12.633,3.292-18.525,0c-10.164-5.68-24.247-13.361-24.247-27.949C222.013,405.599,237.016,393.337,255.523,393.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M263.731,447.968c-10.164-7.302-24.247-17.178-24.247-35.934c0-6.147,1.632-11.838,4.266-16.868 c-12.676,3.905-21.737,13.832-21.737,25.559c0,14.588,14.083,22.269,24.247,27.949c5.892,3.292,12.634,3.292,18.525,0 c0.045-0.025,0.096-0.054,0.142-0.08C264.533,448.353,264.118,448.247,263.731,447.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D26437"
    },
    d: "M256,96.047l-16.059,0.803C126.521,107.015,30.854,223.749,0.372,374.956 c-0.125,0.621-0.249,1.242-0.372,1.864c0,0,49.151-50.767,107.036-36.784C114.274,134.366,242.558,96.047,256,96.047z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxUserIcon);
export default __webpack_public_path__ + "static/media/fox-user-icon.860f5e5fec0a7a3d482cbea303b2b5d7.svg";
export { ForwardRef as ReactComponent };